export class IgnoredError extends Error {}
